import React from 'react';

const FormBuilderContext = React.createContext({});

export default FormBuilderContext;
